export const getOptionIndex = (options, value) => {
    const index = options.findIndex((item) => item.value === value);    
    return index !== -1 ? index : 0;
}

export const getOptionValueByLabel = (options, label) => {
    const index = options.findIndex((item) => item.label === String(label));   
    return index !== -1 ? index : 0;
}